import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper';
import ReactPlayer from 'react-player'

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "./videogallery-styles.css";

export const VideoGallery = (props) => {
    const modelCtx = useContext(ModelContext);

    const [currentIndexVideo, setCurrentIndexVideo] = useState(0);
    const [playVideo, setPlayVideo] = useState(false);

    const [videos, setVideos] = useState([{
        videoUrl: "",
        videoPoster: "",
        videoToolTip: ""
    }]);

    useEffect(() => {
        const getVideos = async () => {

            const input = modelCtx.inputModelData;
            if (input.idBasicModel !== 0) {

                const response = await fetch("/api/model/video", {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        setVideos(data);
                    }
                } else {
                    // Error
                }
            }
        }
        getVideos();
    }, [modelCtx.inputModelData]);

    const handleClickPreview = () => {
        setPlayVideo(true);
    };

    const handleChangeVideo = (indexVideo) => {
        setCurrentIndexVideo(indexVideo);
    };


    return (
        <>
            <div className="row">
                <div className="col-12 bg-blue descriptions">
                    <div className="box">
                        <p className="color-white wow fadeInUp" data-wow-delay="0.4s">
                            <span className="title1">Video gallery</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <p>&nbsp;</p>
            </div>
            <div className="row justify-content-center">
                <ReactPlayer
                    url={videos[currentIndexVideo].videoUrl}
                    controls={true}
                    light={videos[currentIndexVideo].videoPoster}
                    onClickPreview={handleClickPreview}
                    playing={playVideo}
                    className="videogallery-player"
                />
            </div>
            <div className="row">
                <p>&nbsp;</p>
            </div>
            <div className="row">
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={10}
                    slidesPerView={3}
                    navigation
                    className="videogallery-slider-layout"
                >

                    {videos.map((v, i) => (
                        <SwiperSlide key={i} className="videogallery-slider-item" onClick={() => handleChangeVideo(i)} >
                            <img src={v.videoPoster}
                                alt={v.videoToolTip} className="videogallery-slider-thumbs" /><br />
                                <p className="text4">{v.videoToolTip}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="row pb-5">
                <div className="clear"></div>
            </div>
        </>
    );
};

export default VideoGallery;
